module.exports = __webpack_public_path__ + "media/booking/caret-right-ce1e94a9.svg";